import { createContext, useContext } from 'react';

import type { Stripe } from '@stripe/stripe-js';

export interface StripeContextValue {
  stripe?: Stripe;
  stripeLoadError?: Error;
}

const InitialValue: StripeContextValue = {};

export const StripeContext = createContext(InitialValue);

/** Return the stripe context value. */
export function useStripe(): StripeContextValue {
  return useContext(StripeContext);
}
